import React from "react";

const About = () => (
  <div className="soon">
    <div className="default-container">
      <div className="def-title">Tuuli légtechnika</div>
      <div>
        Légtechnikai, szellőzéstechnikai tervezés, kivitelezés. Központi
        hőcserélős, decentrális hőcserélős, vagy csak egyszerű axiál és
        radiálventillátorok beépítése, lakóépületekbe (fürdőszobai, konyhai),
        üzlethelyiségekbe, éttermekbe, irodákba, üzemcsarnokokba, raktárakba,
        robbanásveszélyes területekre.
      </div>
      <br />
      <br />
      <div>
        Cégünk elsősorban kivitelezéssel foglalkozik. Raktárkészlettel nem
        rendelkezünk, de ha igény van rá, akkor az anyagbeszerzést is tudjuk
        vállalni.
      </div>
    </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js